(function() { module.exports = window["gettext"]; }());


//////////////////
// WEBPACK FOOTER
// external "gettext"
// module id = 3
// module chunks = 88